import firebase from 'firebase';

interface RawTimeStamp {
    _seconds: number,
    _nanoseconds: number
}

export function toTimeStamp(obj: RawTimeStamp): firebase.firestore.Timestamp {
    return new firebase.firestore.Timestamp(obj._seconds, obj._nanoseconds)
}